<template>
	<div class="max-w-full overflow-hidden">
		<slot name="top">
			<nk-carousel aria-label="Durchlaufende Bilder" variant="hero-slim">
				<template v-if="shuffledHeroImages">
					<nk-carousel-slide
						v-for="(heroImage, heroImageIndex) in shuffledHeroImages"
						:key="`heroImage-${heroImageIndex}`"
						:bg-image="heroImage.src"
						:bg-image-alt="heroImage.alt"
						:bg-image-copyright="heroImage.copyright"
						bg-image-copyright-position="left top"
					/>
				</template>
				<template v-else-if="defaultHeroImages">
					<nk-carousel-slide
						v-for="(defaultImage, defaultImageIndex) in defaultHeroImages"
						:key="`defaultImage-${defaultImageIndex}`"
						:bg-image="`/static-images/${defaultImage}`"
					/>
				</template>
			</nk-carousel>
			<nk-breadcrumb
				:breadcrumbs="page.breadcrumbs"
				:home-path="homePath"
				:home-title="homeTitle"
			/>
		</slot>
		<NkWrapper v-if="page.isLoading && !page.isQueryOnlyChanging" spacing="xl">
			<NkLoader color="primary" />
		</NkWrapper>
		<nk-container v-else>
			<nk-wrapper spacing="lg">
				<nk-row data-sticky-container gutter="10">
					<nk-col
						order="2"
						order-lg="1"
						cols="full"
						:lg="
							emptySidebar && $slots.sidebar === undefined ? '10/12' : '8/12'
						"
					>
						<NkWrapper
							v-if="page.isLoading && page.isQueryOnlyChanging"
							spacing="xl"
						>
							<NkLoader color="primary" />
						</NkWrapper>
						<main v-else-if="page.context">
							<slot name="content">
								<template
									v-for="(module, indexModuleContent) in page.context.filter(
										module =>
											module.slotName === 'content' ||
											typeof module.slotName === 'undefined',
									)"
									:key="indexModuleContent"
								>
									<component
										v-bind="{context: module.context, options: module.options}"
										:is="componentName(module.template)"
									/>
								</template>
							</slot>
						</main>
					</nk-col>
					<nk-col
						v-if="!emptySidebar || $slots.sidebar !== undefined"
						order="1"
						order-lg="2"
						cols="full"
						lg="4/12"
						offset
					>
						<nk-sidebar v-if="page.context">
							<slot name="sidebar">
								<template
									v-for="(module, indexModuleSidebar) in page.context.filter(
										module => module.slotName === 'sidebar',
									)"
									:key="indexModuleSidebar"
								>
									<component
										v-bind="{context: module.context, options: module.options}"
										:is="componentName(module.template)"
									/>
								</template>
							</slot>
						</nk-sidebar>
					</nk-col>
				</nk-row>
			</nk-wrapper>
		</nk-container>
		<slot name="bottom" />
	</div>
</template>

<script>
import pageLayout from '#nk/mixins/page-layout';
import {useCMS} from '#nk/composables/cms';

export default {
	name: 'NkPageReversed',

	mixins: [pageLayout],

	props: {
		homePath: {
			type: String,
			required: false,
			default: '/',
		},
		homeTitle: {
			type: String,
			required: false,
			default: 'Startseite',
		},
	},

	setup() {
		const page = useCMS();

		return {
			page,
		};
	},
};
</script>
